module.exports = __webpack_public_path__ + "img/bgc1.58f14635.png";